import { eventBus } from '../services';
let AddToCartButton = function ($element) {
  let $this = {};
  $this.classes = {
    loading: 'loading',
    productId: false,
  };
  $this.selectors = {
    addToCartText: '[sh-add-to-cart-text]',
  };

  $this.init = function () {
    $this.element = $element;
    $this.productId = $this.element.dataset.productId;
    $this.addToCartText = $this.element.querySelector(
      $this.selectors.addToCartText,
    );
    eventBus.on(eventBus.types.AddingToCart, $this.addingToCart);
    eventBus.on(eventBus.types.AddedToCart, $this.addedToCart);
  };

  $this.addingToCart = function ($data) {
    if ($this.productId == $data.detail.id) {
      $this.element.classList.add($this.classes.loading);
      $this.addToCartText.innerText = 'Adding...';
    }
  };

  $this.addedToCart = function ($data) {
    if ($data.detail.success == true) {
      if ($this.productId == $data.detail.variant.product_id) {
        $this.element.classList.remove($this.classes.loading);
        $this.addToCartText.innerText = 'Cart Updated.';
        window.setTimeout(function () {
          $this.addToCartText.innerText = 'Add To Cart';
        }, 1000);
      }
    } else {
      $this.element.classList.remove($this.classes.loading);
      $this.addToCartText.innerText = 'Add To Cart';
    }
  };
  $this.init();
  return $this;
};
export default AddToCartButton;
